module.exports = __webpack_public_path__ + "img/aa_logo.0d49ad1c.jpeg";